module.exports = __webpack_public_path__ + "static/media/ungaRAE_30_145_bpm.dfdaa119.mp3";